import { erpAxios } from '..';

const getAnalysis = async (brojZahtjeva) => {
  const { data } = await erpAxios.get(`/analiza/${brojZahtjeva}`);
  return data;
};

export default getAnalysis;
